import { idleTiming } from '@Constants/CommonConstants';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import AppStorage from '@Services/AppStorage';
import Catalyst from '@Services/Catalyst';
import Heartbeat from '@Services/Heartbeat';
import Auth from '@Services/Auth';
import store from '@Store';
import { updateDialog, closeDialog } from '@Containers/Dialogs/DialogsActions';
import { typeOfIdleWarningModal } from '@Containers/IdleWarningModal/IdleWarningModalConstants';

const DOCUMENT_NOTIFICATION_TITLE = 'Session expiration';

let userActionInterval = null;
let notification = null;
let browserNotification = null;
let titleNotificationInterval = null;
let defaultTitle = window.document.title;

export function start() {
  // eslint-disable-next-line no-use-before-define
  userActionInterval = setInterval(checkUserAction, idleTiming.USER_ACTION_CHECK_INTERVAL);
}

export function stop() {
  if (userActionInterval) {
    clearInterval(userActionInterval);
    userActionInterval = null;
  }
}

function checkUserAction() {
  const sessionTimeout = getValueByNs(Auth.getUser(), 'details.sessionTimeout', 0) * 1000;
  if (sessionTimeout === 0) {
    stop();
    return;
  }
  const timeSinceLastAction = Date.now() - Auth.getLastActionTime();
  if (!notification && sessionTimeout - timeSinceLastAction <= idleTiming.NOTIFICATION_TIMEOUT) {
    // If user was inactive and it's N minutes before session expiry
    // eslint-disable-next-line no-use-before-define
    notifyAboutIdle(sessionTimeout - timeSinceLastAction);
  } else if (notification && sessionTimeout - timeSinceLastAction > idleTiming.NOTIFICATION_TIMEOUT) {
    // If notification was shown but user triggered an action
    // eslint-disable-next-line no-use-before-define
    hideIdleNotifications();
  }
}

export function processSessionExpiry() {
  stop();
  Heartbeat.processSessionExpiry();
}

function notifyAboutIdle(timeLeft) {
  Catalyst.trackError({
    message: `${DOCUMENT_NOTIFICATION_TITLE} Reaxys recognized no activity and will close the session`,
  });
  store.dispatch(
    updateDialog({
      id: typeOfIdleWarningModal,
      dialogType: typeOfIdleWarningModal,
      movable: false,
      backdrop: false,
      closeButton: false,
      className: 'idle-warning-modal-dialog-wrap',
      timeLeft,
    })
  );
  notification = true;

  const isNotificationShownInOtherTabs = AppStorage.instance.get('idleNotification');
  if (window.Notification && Notification.permission === 'granted' && !isNotificationShownInOtherTabs) {
    browserNotification = new Notification('Reaxys', {
      body: `Session will be expired soon`,
    });

    AppStorage.instance.set('idleNotification', true);
  }

  defaultTitle = window.document.title;
  titleNotificationInterval = setInterval(() => {
    window.document.title = window.document.title === DOCUMENT_NOTIFICATION_TITLE ? defaultTitle : DOCUMENT_NOTIFICATION_TITLE;
  }, 1000);
}

function hideIdleNotifications() {
  store.dispatch(
    closeDialog({
      id: typeOfIdleWarningModal,
    })
  );
  notification = null;

  if (browserNotification) {
    browserNotification.close();
    AppStorage.instance.set('idleNotification', false);
  }

  clearInterval(titleNotificationInterval);
  window.document.title = defaultTitle;
}
